// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import RegistrationFormStep1Component from '../../components/registration-form/step-1/step-1';
import RegistrationFormStep2Component from '../../components/registration-form/step-2/step-2';
import RegistrationFormStep3Component from '../../components/registration-form/step-3/step-3';
import RegistrationFormStep4Component from '../../components/registration-form/step-4/step-4';
import RegistrationFormStep5Component from '../../components/registration-form/step-5/step-5';
import RegistrationFormStep6Component from '../../components/registration-form/step-6/step-6';
import RegistrationFormStep7Component from '../../components/registration-form/step-7/step-7';
import RegistrationFormStep8Component from '../../components/registration-form/step-8/step-8';
import RegistrationFormStep9Component from '../../components/registration-form/step-9/step-9';
import RegistrationFormStep10Component from '../../components/registration-form/step-10/step-10';
import RegistrationFormStep11Component from '../../components/registration-form/step-11/step-11';

// Primereact imports
import { Toast } from 'primereact/toast';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './registration-form.scss';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';
import { isMobileOnly } from 'react-device-detect';

// Redux
import { getUserForm, updateFormStep, updateStep11State } from '../../redux/actions/form';
import { connect } from 'react-redux';
import FinancialService from '../../redux/services/finance';

// Utils
import { FORM_STEP_11_STATE, STEP_STATE_SUBMITTED } from '../../common/constants';

class RegistrationFormPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            activeStep: 1
        };
    }

    componentDidMount() {
        // Check if the page was called from SIBS
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let formIdParam = params.get('id');

        if(formIdParam !== null) {
            FinancialService.getCreditCardCheckoutStatus(formIdParam)
            .then((response) => {
                let successCodesRegex = new RegExp('^(000\.000\.|000\.100\.1|000\.[36])');

                // Confirm if payment was successful
                if(successCodesRegex.test(response.checkout.result.code)) {
                    this.submitForm();
                }
                else {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.credit-card-error"), life: 5000 });
                }
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("checkout.messages.error"), life: 3000 });
            });

            /*this.setState({
                showCardForm: false
            });*/
            // TODO: Hide form
        }
        else {
            //this.props.getUserForm(1);
        }
    }



    navigateToPreviousStep() {
        const previousStep = this.state.activeStep - 1;

        this.setState({
            activeStep: previousStep
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    navigateToNextStep() {
        const nextStep = this.state.activeStep + 1;

        this.setState({
            activeStep: nextStep
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    isStepActive(step) {
        return this.state.activeStep === step;
    }

    goToStep(step) {
        this.setState({
            activeStep: step
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    getFormStepClass(stepState, active) {
        if(active) return "stepper-item current c-pointer";

        if(stepState === STEP_STATE_SUBMITTED) {
            return "stepper-item completed c-pointer";
        }

        return "stepper-item c-pointer";
    }

    submitForm() {
        this.props.updateStep11State(STEP_STATE_SUBMITTED);

        this.props.updateFormStep(1, 
            [
                { key: FORM_STEP_11_STATE, value: STEP_STATE_SUBMITTED }
            ],
            null);
    }

    render() {
        return (
            <div>
                <PageTitleComponent title={this.props.t("registration-form.title")} />
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10">
                        {
                            isMobileOnly ?
                                <div className="stepper-wrapper">
                                    {
                                        this.isStepActive(1) ? 
                                            <div className="stepper-item c-pointer" onClick={(evt) => this.goToStep(this.state.activeStep - 1)}>
                                                <div className="step-counter">{"<"}</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(1) ? 
                                            <div className={this.getFormStepClass(this.props.step1State, this.isStepActive(1))} onClick={(evt) => this.goToStep(1)}>
                                                <div className="step-counter">1</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(2) ? 
                                            <div className={this.getFormStepClass(this.props.step2State, this.isStepActive(2))} onClick={(evt) => this.goToStep(2)}>
                                                <div className="step-counter">2</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(3) ? 
                                            <div className={this.getFormStepClass(this.props.step3State, this.isStepActive(3))} onClick={(evt) => this.goToStep(3)}>
                                                <div className="step-counter">3</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(4) ? 
                                            <div className={this.getFormStepClass(this.props.step4State, this.isStepActive(4))} onClick={(evt) => this.goToStep(4)}>
                                                <div className="step-counter">4</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(5) ? 
                                            <div className={this.getFormStepClass(this.props.step5State, this.isStepActive(5))} onClick={(evt) => this.goToStep(5)}>
                                                <div className="step-counter">5</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(6) ? 
                                            <div className={this.getFormStepClass(this.props.step6State, this.isStepActive(6))} onClick={(evt) => this.goToStep(6)}>
                                                <div className="step-counter">6</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(7) ? 
                                            <div className={this.getFormStepClass(this.props.step7State, this.isStepActive(7))} onClick={(evt) => this.goToStep(7)}>
                                                <div className="step-counter">7</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(8) ? 
                                            <div className={this.getFormStepClass(this.props.step8State, this.isStepActive(8))} onClick={(evt) => this.goToStep(8)}>
                                                <div className="step-counter">8</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(9) ? 
                                            <div className={this.getFormStepClass(this.props.step9State, this.isStepActive(9))} onClick={(evt) => this.goToStep(9)}>
                                                <div className="step-counter">9</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(10) ? 
                                            <div className={this.getFormStepClass(this.props.step10State, this.isStepActive(10))} onClick={(evt) => this.goToStep(10)}>
                                                <div className="step-counter">10</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(11) ? 
                                            <div className={this.getFormStepClass(this.props.step11State, this.isStepActive(11))} onClick={(evt) => this.goToStep(11)}>
                                                <div className="step-counter">11</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.isStepActive(1) ? 
                                            <div className="stepper-item c-pointer" onClick={(evt) => this.goToStep(this.state.activeStep + 1)}>
                                                <div className="step-counter">{">"}</div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                                :
                                <div className="stepper-wrapper">
                                    <div className={this.getFormStepClass(this.props.step1State, this.isStepActive(1))} onClick={(evt) => this.goToStep(1)}>
                                        <div className="step-counter">1</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step2State, this.isStepActive(2))} onClick={(evt) => this.goToStep(2)}>
                                        <div className="step-counter">2</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step3State, this.isStepActive(3))} onClick={(evt) => this.goToStep(3)}>
                                        <div className="step-counter">3</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step4State, this.isStepActive(4))} onClick={(evt) => this.goToStep(4)}>
                                        <div className="step-counter">4</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step5State, this.isStepActive(5))} onClick={(evt) => this.goToStep(5)}>
                                        <div className="step-counter">5</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step6State, this.isStepActive(6))} onClick={(evt) => this.goToStep(6)}>
                                        <div className="step-counter">6</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step7State, this.isStepActive(7))} onClick={(evt) => this.goToStep(7)}>
                                        <div className="step-counter">7</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step8State, this.isStepActive(8))} onClick={(evt) => this.goToStep(8)}>
                                        <div className="step-counter">8</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step9State, this.isStepActive(9))} onClick={(evt) => this.goToStep(9)}>
                                        <div className="step-counter">9</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step10State, this.isStepActive(10))} onClick={(evt) => this.goToStep(10)}>
                                        <div className="step-counter">10</div>
                                    </div>
                                    <div className={this.getFormStepClass(this.props.step11State, this.isStepActive(11))} onClick={(evt) => this.goToStep(11)}>
                                        <div className="step-counter">11</div>
                                    </div>
                                </div>
                        }
                        
                        {
                            this.state.activeStep === 1 ?
                                <RegistrationFormStep1Component onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 2 ?
                                <RegistrationFormStep2Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 3 ?
                                <RegistrationFormStep3Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 4 ?
                                <RegistrationFormStep4Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 5 ?
                                <RegistrationFormStep5Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 6 ?
                                <RegistrationFormStep6Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 7 ?
                                <RegistrationFormStep7Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 8 ?
                                <RegistrationFormStep8Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 9 ?
                                <RegistrationFormStep9Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 10 ?
                                <RegistrationFormStep10Component onBack={() => this.navigateToPreviousStep()} onNext={() => this.navigateToNextStep()} />
                                : null
                        }
                        {
                            this.state.activeStep === 11 ?
                                <RegistrationFormStep11Component onBack={() => this.navigateToPreviousStep()} onSubmit={() => this.submitForm()} />
                                : null
                        }
                    </div>
                    <div className='col-1'></div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        step1State: state.form.step1State,
        step2State: state.form.step2State,
        step3State: state.form.step3State,
        step4State: state.form.step4State,
        step5State: state.form.step5State,
        step6State: state.form.step6State,
        step7State: state.form.step7State,
        step8State: state.form.step8State,
        step9State: state.form.step9State,
        step10State: state.form.step10State,
        step11State: state.form.step11State
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep11State: (state) => { dispatch(updateStep11State(state)) },
        getUserForm: (userRef) => { dispatch(getUserForm(userRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(RegistrationFormPage)));